import type { TraceObservabilityLinks as TraceObservabilityLinksType } from "../../types";
import styles from "./TraceObservabilityLinks.module.css";

export interface TraceObservabilityLinksProps {
  links?: TraceObservabilityLinksType;
}

export function TraceObservabilityLinks({ links }: TraceObservabilityLinksProps) {
  const traceUrl = links?.honeycomb_trace_url;
  const spanUrl = links?.honeycomb_span_url;

  if (!traceUrl && !spanUrl) {
    return null;
  }

  return (
    <section className={styles.container} aria-label="Observability links">
      <h2 className={styles.heading}>Observability</h2>
      <ul className={styles.linkList}>
        {traceUrl && (
          <li>
            <a
              href={traceUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.link}
              data-testid="honeycomb-trace-link"
            >
              Honeycomb trace
            </a>
          </li>
        )}
        {spanUrl && (
          <li>
            <a
              href={spanUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.link}
              data-testid="honeycomb-span-link"
            >
              Honeycomb span
            </a>
          </li>
        )}
      </ul>
    </section>
  );
}
